"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItem = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const clsx_1 = __importDefault(require("clsx"));
const Grow_1 = __importDefault(require("@material-ui/core/Grow"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const Popper_1 = __importDefault(require("@material-ui/core/Popper"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const menu_styles_1 = require("./menu-styles");
const sub_menu_1 = require("./sub-menu");
function MenuItem({ item, index, opened, onClick, onHover, classOverrides, anchorEl, }) {
    var _a;
    const classes = (0, menu_styles_1.useStyles)();
    const handleClick = (0, event_callback_hook_1.useEventCallback)((e) => {
        onClick(e, index);
    });
    const handleHover = (0, event_callback_hook_1.useEventCallback)((e) => {
        onHover(e, index);
    });
    const { pathname } = (0, react_router_dom_1.useLocation)();
    return (react_1.default.createElement(MenuItem_1.default, { component: item.href ? 'a' : 'div', href: item.href, className: (0, clsx_1.default)(classes.menuItem, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menuItem, ((_a = item === null || item === void 0 ? void 0 : item.isActive) === null || _a === void 0 ? void 0 : _a.call(item, pathname)) && [
            classes.activeMenuItem,
            classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.activeMenuItem,
        ]), onMouseEnter: handleHover, onClick: (e) => {
            e.preventDefault();
            handleClick(e);
        }, disableRipple: true },
        react_1.default.createElement(Typography_1.default, { variant: "inherit", className: (0, clsx_1.default)(classes.menuItemText, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menuItemText) }, item.label),
        opened && (react_1.default.createElement(Popper_1.default, { open: opened, anchorEl: anchorEl, placement: "bottom-start", style: { zIndex: 1050 }, transition: true, container: document.getElementById('menu-bar') }, ({ TransitionProps }) => {
            var _a;
            return (react_1.default.createElement(Grow_1.default, { ...TransitionProps, style: { transformOrigin: '0 0 0' } },
                react_1.default.createElement(sub_menu_1.SubMenu, { topLevel: true, items: (_a = item.items) !== null && _a !== void 0 ? _a : [], opened: opened, classOverrides: classOverrides })));
        }))));
}
exports.MenuItem = MenuItem;
//# sourceMappingURL=menu-item.js.map